export enum Role {
    Admin = 'admin',
    Entity = 'entity',
    EntityAdmin = 'entity_admin',
    Assessor = 'assessor',
    LeadAssessor = 'assessor_lead',
    TechnicalReviewer = 'technical_reviewer',
}
